import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { FlatTreeControl, NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener, MatTreeNestedDataSource } from '@angular/material/tree';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTree } from '@angular/material/tree';
import { environment } from 'src/environments/environment';

export class AideSaisie {
  name: string;
  children: AideSaisie[] = [];

  constructor(name: string) {
    this.name = name;
  }

  public clone(): AideSaisie {
    const clone = new AideSaisie(this.name);
    for (let child of this.children) {
      clone.children.push(child.clone());
    }
    return clone;
  }
}

/** Flat node with expandable and level information */
interface FlatTreeNode {
  expandable: boolean;
  name: string;
  level: number;
}

@Component({
  selector: 'app-saisie-guidee',
  templateUrl: './saisie-guidee.fragment.html',
  styleUrls: [
    './saisie-guidee.fragment.scss',
    '../modal.fragment.scss'
  ]
})
export class SaisieGuideeFragment implements OnInit {
  private _transformer = (node: AideSaisie, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level: level,
    };
  }

  treeControl = new FlatTreeControl<FlatTreeNode>(node => node.level, node => node.expandable);
  treeFlattener = new MatTreeFlattener(this._transformer, node => node.level, node => node.expandable, node => node.children);
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  @ViewChild('treeSelector') tree: MatTree<AideSaisie>;
  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;


  ligneSaisieGuidee: any;

  @Output() public closeEmitter = new EventEmitter();

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeAddEditModal();
    }
  }

  constructor(
  ) { }

  hasChild = (_: number, node: FlatTreeNode) => node.expandable;

  ngOnInit(): void {
    if (this.ligneSaisieGuidee) {
      this.dataSource.data = JSON.parse(this.ligneSaisieGuidee.aideSaisie);
    }
  }

  public closeAddEditModal(object?: any): void {
    if (object) {
      this.closeEmitter.emit(object);
    } else {
      this.closeEmitter.emit(null);
    }
  }

  use(node: FlatTreeNode) {
    this.ligneSaisieGuidee.value = this.getNestedString(node);
    this.closeAddEditModal(this.ligneSaisieGuidee);
  }

  getParent(node: FlatTreeNode) {
    const { treeControl } = this;
    const currentLevel = treeControl.getLevel(node);

    if (currentLevel < 1) {
      return null;
    }

    const startIndex = treeControl.dataNodes.indexOf(node) - 1;

    for (let i = startIndex; i >= 0; i--) {
      const currentNode = treeControl.dataNodes[i];

      if (treeControl.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
  }

  getNestedString(node: FlatTreeNode) {
    let result = node.name;
    let hasParent = true;
    if (node.level < 1) {
      hasParent = false;
    }
    let currentNode = node;
    while (hasParent) {
      currentNode = this.getParent(currentNode);
      result = currentNode.name + " " + result;
      if (currentNode.level < 1) {
        hasParent = false;
      }
    }
    return result
  }

  closeModal(){
    this.closeEmitter.emit()
  }

}
